export default "__VITE_ASSET__XT4KHiWR__"